import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { AuthService } from "../services/auth.service";
import { SharedService } from "../services/shared.service";

export const canActivate: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
): Observable<boolean | UrlTree> | boolean | UrlTree => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const redirectParam = route.queryParamMap.get('redirect');
    const { decoded: redirectUrl } = SharedService.decodeAndValidateRedirectUrl(redirectParam);

    if (authService.isAuthenticated()) {
        window.location.href = redirectUrl ?? environment.sandbox_console_host;
        return false;
    }

    if (authService.getRefreshToken()) {
        // Delegate to /authorize which shows the Rive loading animation while refreshing
        return router.createUrlTree(['/authorize'], { queryParams: redirectParam ? { redirect: redirectParam } : {} });
    }

    return true;
}

export const isNotLoggedInGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
    canActivate(route, state)
